import { isJSON, getData, putData } from '../utilities/data';

export default class ProjectInfo {

  constructor() {

    // Open state
    this.isOpen = false;

    // Initialise the buttons
    this.initButtons();
  }

  initButtons() {
    let self = this;

    // Menu button
    let projectInfoButtons = document.querySelectorAll('.project-info-button');
    projectInfoButtons.forEach(el => el.addEventListener('click', () => self.open()));

    // Close
    let projectInfoContainer = document.getElementById('project-info');
    if (projectInfoContainer) projectInfoContainer.addEventListener('click', () => self.close());
  }

  open() {

    // Open the project info
    let projectInfo = document.getElementById('project-info');
    projectInfo.classList.remove('closed');
    projectInfo.classList.add('opening');

    // Timeout for state reset
    setTimeout(() => {

      // Reset to open
      projectInfo.classList.remove('opening');
      projectInfo.classList.add('open');
    }, 560);
    
    // Set open state
    this.isOpen = true;

    // Lock off vertical overflow
    document.body.style.overflowY = 'hidden';
  }

  close() {
    if (!this.isOpen) return; 

    // Hide the project info
    let projectInfo = document.getElementById('project-info');
    projectInfo.classList.remove('open');
    projectInfo.classList.add('closing');

    // Set open state
    this.isOpen = false;

    // Timeout for state reset
    setTimeout(() => {

      // Reset to closed
      projectInfo.classList.remove('closing');
      projectInfo.classList.add('closed');
    }, 560);

    // Release vertical overflow for normally scrolling pages
    if (!window.fullPage) document.body.style.overflowY = 'visible';
  }
}


// WEBPACK FOOTER //
// ./source/javascript/sections/project-info.js